<template>
  <div class="w-full h-full  overflow-hidden" :class="data.layout === 'BannerLong' ? 'flex' : ''">
    <!-- <column-header class="mb-10px" :title="title" :showMore="data.showMore" @loadMore="loadMore" /> -->
    <el-image
      v-for="(item, index) in bannerList"
      :key="index"
      :class="['flex', 'items-center', 'justify-center']"
      :style="{
        width: `calc(100% / ${
          bannerList.length > 1 && data.layout === 'BannerLong' ? bannerList.length : 1
        })`,
        height: `calc(100% / ${
          bannerList.length > 1 && data.layout === 'BannerShort' ? bannerList.length : 1
        } )`,
      }"
      :src="`${fileUrl}${item.imageFile}`"
      :fit="data.imageFit || 'fill'"
      @click="toDetail(item)"
    >
      <div slot="error" class="image-slot"></div>
    </el-image>
  </div>
</template>
<script>
import { ColumnTableApi } from '@wiz-api/workbench'
import addRequestQueue from '@/assets/js/RequestQueue'

// const columnHeader = () => {
//   return import('./ColumnHeader')
// }
const columnTableApi = new ColumnTableApi()
export default {
  name: 'bannerLong',
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
    mode: {
      type: String,
      default: '',
    },
  },
  components: {
    // columnHeader,
  },
  computed: {
    fileUrl() {
      const fileServer = Wiz.GetModuleServer('file-management')
      return `${fileServer}/api/file-management/files/public/image/`
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        if (!_.isEmpty(val)) {
          this.title = val.title || 'banner'
          if (!_.isEmpty(val.dataSource)) {
            this.getCompentData(val)
          }
        }
      },
    },
  },
  data() {
    return {
      bannerList: [],
      title: 'Banner',
    }
  },
  methods: {
    loadMore() {
      if (this.mode !== 'update') {
        this.$router.push({
          path: `/portal/homepage?columnId=${this.data.dataSource}`,
        })
      }
    },
    async toDetail(row) {
      if (this.mode === 'update') {
        return
      }
      if (row.jumpType === 2) {
        row.skipMode === 1 ? window.open(row.url) : (window.location.href = row.url)
      } else if (row.jumpType === 1) {
        const path = `/portal/homepage?columnId=${row.jumpColumn}`
        row.skipMode === 1
          ? window.open(`${window.location.origin}${window.location.hash ? '/#' : ''}${path}`)
          : this.$router.push(path)
      }
    },
    async getCompentData(obj) {
      const [err, res] = await addRequestQueue(() => {
        return columnTableApi.getBinnerColumnTable(1, obj.pageSize ? obj.pageSize : 1, {
          columnId: obj.dataSource,
          isShow: true,
        })
      })
      if (!err && res) {
        this.bannerList = []
        _.map(res.items, (it) => {
          it.isShow === true ? this.bannerList.push(it) : ''
        })
      }
    },
    filterHeight() {
      let str = ''
      if (this.data.layout === 'BannerLong') {
        this.bannerList.length > 1
          ? (str = `w-[calc(100%/${this.bannerList.length})] h-full`)
          : (str = 'w-full h-full')
      } else {
        this.bannerList.length > 1
          ? (str = `h-[calc(100%/${this.bannerList.length})] w-full`)
          : (str = 'w-full h-full')
      }
      return str
    },
  },
}
</script>

<style lang="scss" scoped></style>
